<template>
  <div class="luckyBox">
    <div class="closeBox" @click="$emit('closeFn')">×</div>
    <p class="title">剩余抽奖次数：{{lotteryDetails.times || 0}}</p>
    <LuckyGrid v-if="apiStatus" ref="myLucky" width="400px" height="400px" :prizes="prizes" :blocks="blocks" :buttons="buttons"
      :activeStyle="activeStyle" :defaultConfig="defaultConfig" @start="startCallback" @end="endCallback" />
    <div v-else style="width: 400px;height: 400px;background-color: rgb(221 221 221);border-radius: 10px;display: flex;align-items: center;justify-content: center;"><a-spin size="large" /></div>
  </div>
</template>
  
<script>
import { getAction } from "@/api/manage";
export default {
  name: "LuckyGridPage",
  props:['luckyInfo'],
  watch:{
    luckyInfo(e){
      this.lotteryInfo = e
    }
  },
  data() {
    return {
      apiStatus:false,
      lotteryInfo:{},
      lotteryDetails:{},
      blocks: [
        {
          padding: "13px",
          background: "rgb(221 221 221)",
          borderRadius: "10px",
        },
      ],
      defaultConfig: {
        gutter: 12
      },
      prizes: [
        {
          x: 0,
          y: 0,
          imgs: [{ src: require('../../assets/zanwu.png'), activeSrc: require('../../assets/zanwu.png'), width: '120px', height: '120px' }],
          background: "#fff",
        },
        {
          x: 1,
          y: 0,
          imgs: [{ src: require('../../assets/zanwu.png'), activeSrc: require('../../assets/zanwu.png'), width: '120px', height: '120px' }],
          background: "#fff",
        },
        {
          x: 2,
          y: 0,
          imgs: [{ src: require('../../assets/zanwu.png'), activeSrc: require('../../assets/zanwu.png'), width: '120px', height: '120px' }],
          background: "#fff",
        },
        {
          x: 2,
          y: 1,
          imgs: [{ src: require('../../assets/zanwu.png'), activeSrc: require('../../assets/zanwu.png'), width: '120px', height: '120px' }],
          background: "#fff",
        },
        {
          x: 2,
          y: 2,
          imgs: [{ src: require('../../assets/zanwu.png'), activeSrc: require('../../assets/zanwu.png'), width: '120px', height: '120px' }],
          background: "#fff",
        },
        {
          x: 1,
          y: 2,
          imgs: [{ src: require('../../assets/zanwu.png'), activeSrc: require('../../assets/zanwu.png'), width: '120px', height: '120px' }],
          background: "#fff",
        },
        {
          x: 0,
          y: 2,
          imgs: [{ src: require('../../assets/zanwu.png'), activeSrc: require('../../assets/zanwu.png'), width: '120px', height: '120px' }],
          background: "#fff",
        },
        {
          x: 0,
          y: 1,
          imgs: [{ src: require('../../assets/zanwu.png'), activeSrc: require('../../assets/zanwu.png'), width: '120px', height: '120px' }],
          background: "#fff",
        },
      ],
      buttons: [
        {
          x: 1,
          y: 1,
          radius: "35%",
          pointer: true,
          imgs:[{
            src:require('../../assets/lottery_button.png'),
            width:'120px',
            height:'120px',
            top:'0'
          }],
        },
      ],
      activeStyle: {
        background: "#FFC107",
        fontColor: "#fff",
      },
    };
  },
  created(){this.lotteryInfo = this.luckyInfo},
  mounted() { this.init(this.lotteryInfo.lotteryId) },
  methods: {
    init(id) {
      let _this = this
      getAction('/teaching/teachingLottery/getLottery?id=' + id,).then(res => {
        if (res.success) {
          _this.lotteryDetails = res.result
          for (let i = 0; i < 8; i++) {
            _this.prizes[i].imgs[0].src = res.result.items[i].cover
            _this.prizes[i].imgs[0].activeSrc = res.result.items[i].cover
            _this.prizes[i].orderNum = res.result.items[i].orderNum
            _this.prizes[i].name = res.result.items[i].name
          }
          this.apiStatus = true
        }
      })
    },
    startCallback() {
      let _this = this
      console.log(this.lotteryInfo , 'his.lotteryInfo')
      getAction('/teaching/teachingLottery/start?id=' + this.lotteryInfo.lotteryId).then(res => {
        if (res.success) {
          _this.$refs.myLucky.play();
          const index = _this.prizes.findIndex(v => v.orderNum == res.result)
          let timer = setTimeout(() => {
            _this.$refs.myLucky.stop(index);
            _this.lotteryDetails.times--
            clearTimeout(timer)
          })

        } else {
          _this.$message.error(res.message);
        }
      })
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      console.log(prize  , '中奖信息？');
      this.$notification.open({
        duration:null,
        message: '中奖提示',
        description:`恭喜获得《${prize.name}》奖品`,
       });
    },
  },
};
</script>

<style lang="less" scoped>
.luckyBox {
  width: 100vw;
  height: 100vh;
  background: #00000081;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .title{
    font-size: 24px;
    line-height: 45px;
    color: #fff;
  }

  .closeBox {
    width: 45px;
    height: 45px;
    position: absolute;
    top: 60px;
    right: 60px;
    border: 3px solid #fff;
    border-radius: 50%;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    font-size: 36px;
    color: #fff;
    font-weight: bold;
  }
}
</style>